<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>
            
            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" >

                <div class="row mb-32 gy-0 dash-top">

                    <div class="col-12" style="padding-left: 5px; padding-right: 5px;">

                        
                        <div class="row g-32">

                            

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                
                                

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none">Security Settings</h3>
                                                <p class="hp-p1-body"></p>

                                                <div class="mm-none">
                                                    <div class="divider mt-18 mb-16 "></div>
                                                </div>

                                                <h4 style="margin-top: 50px; margin-bottom: 30px;">Change Password</h4>

                                                <form @submit.prevent="updatePasswordM" style="margin-bottom: 50px;">

                                                    <div class="mb-24">
                                                    
                                                    <input type="password" class="form-control" v-model="currentPassword" required aria-describedby="emailHelp" placeholder="Current password">
                                                    
                                                    </div>

                                                    <div class="mb-24">
                                                        
                                                        <input type="password" class="form-control" v-model="newPassword" required aria-describedby="emailHelp" placeholder="New password">
                                                        
                                                    </div>

                                                    <div class="mb-24">
                                                        
                                                        <input type="password" class="form-control" v-model="confirmPassword" required aria-describedby="emailHelp" placeholder="Confirm new password">
                                                        
                                                    </div>

                                                    <div class="mb-24" style="margin-top: 50px; display: flex; justify-content: flex-start;" >

                                                        <button class="btn btn-primary" style="color: #ffffff;">Save</button>

                                                    </div>

                                                </form>
                                                
                                                <div class="divider mt-18 mb-16"></div>

                                                <div class="row g-24" >
                                                    <div class="col-12 mt-32">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-shield-keyhole-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Two Factor Authentication</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Enable 2FA to add an extra layer of security to your account beyond just a password</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Adds an extra layer of security</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch"  @click="setAuth">
                                                    <input class="form-check-input" type="checkbox" id="authInput" checked v-if="auth == 'yes'">
                                                    <input class="form-check-input" type="checkbox" id="authInput" v-else>
                                                    <label class="form-check-label" for="authInput" v-if="auth == 'yes'">

                                                    </label>
                                                    <label class="form-check-label" for="authInput" v-else>
                                                        
                                                    </label>
                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-32">
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="ri-tv-2-line hp-text-color-dark-0 me-16"
                                                                        style="font-size: 24px;"></i>

                                                                    <div>
                                                                        <h5 class="mb-0">Session Monitor</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Enable this setting to log information about your sign in sessions</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Log session information.</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="form-check form-switch"  @click="setMonitor">
                                                    <input class="form-check-input" type="checkbox" id="monitorInput" checked v-if="activityMonitor == 'yes'">
                                                    <input class="form-check-input" type="checkbox" id="monitorInput" v-else>
                                                    <label class="form-check-label" for="monitorInput" v-if="activityMonitor == 'yes'">
                                                        
                                                    </label>
                                                    <label class="form-check-label" for="monitorInput" v-else>
                                                        
                                                    </label>
                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                                

                                                

                                                


                                                <div class="mb-24" style="margin-top: 550px;">

                                                        

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody/>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import SettingsBody from '@/components/SettingsBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc } from "firebase/firestore"; 
    import {getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword} from "firebase/auth"
    import { db } from '@/firebase';
    import { MD5 } from 'md5-js-tools';

    export default {

        components: {
            SidebarBody,
            SettingsBody,
            HeaderBody,
            FooterBody,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",

                auth: "",
                email: "",
                activityMonitor: "",

                currentPassword: "",
                newPassword: "",
                confirmPassword: "",

                spamCount1: 0,
                spamCount2: 0,
                spamCount3: 0,

                
            }
        },

        mounted(){

            document.body.style.overflowY = 'hidden';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Security';

            
            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");

            this.getUserInfo();
            
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                //this.$router.go();
            },

            async getUserInfo(){

                this.loadingText = "Getting user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    
                    this.auth = userSnap.data().auth;
                    this.activityMonitor = userSnap.data().activityMonitor;
                    this.email = userSnap.data().email;
                    
                }
                else{
                    this.$router.push({name: 'sign-in'});
                    return;
                }

                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async setAuth(){

                if(this.spamCount1 > 4){
                    return;
                }

                this.spamCount1++;
                this.loadingText = "Saving settings...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.auth == 'yes'){

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        auth: 'no',
                    });

                    this.auth = 'no';

                }

                else{

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        auth: 'yes',
                    });

                    this.auth = 'yes';

                }

                this.successText = "Two Factor Authentication setting was updated successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
            },

            async setMonitor(){

                if(this.spamCount2 > 4){
                    return;
                }

                this.spamCount2++;

                this.loadingText = "Saving settings...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.activityMonitor == 'yes'){

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        activityMonitor: 'no',
                    });

                    this.activityMonitor = 'no';

                }

                else{

                    const UserRef = doc(db, "Users", auth.currentUser.uid);
                    await updateDoc(UserRef, {
                        activityMonitor: 'yes',
                    });

                    this.activityMonitor = 'yes';

                }

                this.successText = "Activity monitor setting was updated successfully.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
            },

            async updatePasswordM(){

                if(this.spamCount3 > 4){
                    this.errorText = "You have exceeded the maximum number of updates for this session."
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                this.spamCount3++;

                this.loadingText = "Updating password...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.newPassword.length < 8){

                    this.errorText = "Password must be at least 8 characters long";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                }

                if(this.newPassword != this.confirmPassword){

                    this.errorText = "Passwords do not match...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                }

                let passwordHash = MD5.generate(String(this.newPassword));

                const user = auth.currentUser;
                const credential = EmailAuthProvider.credential(
                this.email, this.currentPassword );

                reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    updatePassword(user, passwordHash).then(() => {
                        // Update successful
                        this.successText = "Password was updated successfully.";
                        this.$refs.successModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");

                    }).catch((error) => {
                        // An error occurred
                        this.errorText = "An error occured while updating your password...";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;
                    });

                })
                .catch((error) => {
                    
                    this.errorText = "Incorrect password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });

            }

        }
        
    }
</script>